module.exports = __webpack_public_path__ + "static/img/proDetail.6395994e.jpg";